import { render, staticRenderFns } from "./sliderEkle.vue?vue&type=template&id=50217e4a&scoped=true&"
import script from "./sliderEkle.vue?vue&type=script&lang=js&"
export * from "./sliderEkle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50217e4a",
  null
  
)

export default component.exports